import { getAccessKeyForpayment } from "../../util/APIUtils";

/* global initializeEasebuzzCheckout */
export const ProcessPayment = () => {
    const initiatePayment = async (values) => {
        try {
            // 🔹 Call backend to get access_key
            const data = await getAccessKeyForpayment(values || {});

            if (typeof EasebuzzCheckout === "undefined") {
                alert("Easebuzz SDK not loaded. Add script in index.html");
                return;
            }

            // 🔹 Use new EasebuzzCheckout class
            const ebz = new EasebuzzCheckout(data.merchant_key, data.env || "test");

            ebz.initiatePayment({
                key: data.merchant_key,
                txnid: data.txnid,
                amount: data.amount,
                firstname: data.firstname,
                email: data.email,
                phone: data.phone,
                productinfo: data.productinfo,
                access_key: data.access_key,
                surl: data.surl,
                furl: data.furl,
            });
        } catch (err) {
            console.error("Backend error:", err);
            return { status: "error", error: err };
        }
    };

    return { initiatePayment };
};



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ProcessPayment.js